/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* eslint-disable no-plusplus */
/* eslint-disable global-require */
export const getCountryFromIso = (locale, isoCode) => {
  const countries = require('./country.json');
  for (let i = 0; i < countries.length; i++) {
    if (countries[i].iso_code === isoCode.toUpperCase()) {
      return locale === 'ar' ? countries[i].name_ar : countries[i].name;
    }
  }
};

export const getShippingDaysFromIso = (isoCode) => {
  const shippingDays = {
    EG: '4 - 7',
    SA: '10 - 14',
    AE: '10 - 14',
    OM: '4 - 7',
    BH: '4 - 7',
    IQ: '4 - 7',
  };
  return shippingDays[isoCode];
};

export const getCurrencyFromIso = (locale, isoCode) => {
  const currencies = {
    EG: `${locale === 'ar' ? 'جنيه' : 'EGP'}`,
    SA: `${locale === 'ar' ? 'ريال' : 'Riyal'}`,
    AE: `${locale === 'ar' ? 'درهم' : 'Dirham'}`,
  };
  return currencies[isoCode];
};

export const getPhoneCodeForCountry = (isoCode, locale) => {
  const phoneCodes = {
    EG: `${locale === 'ar' ? '+20' : '+20'}`,
    SA: `${locale === 'ar' ? '+966' : '+966'}`,
    AE: `${locale === 'ar' ? '+971' : '+971'}`,
    OM: `${locale === 'ar' ? '+968' : '+968'}`,
    BH: `${locale === 'ar' ? '+973' : '+973'}`,
    IQ: `${locale === 'ar' ? '+964' : '+964'}`,
  };
  return phoneCodes[isoCode];
};

export const getPhonePlaceHolderByCountry = (locale, isoCode) => {
  const phones = {
    EG: `${locale === 'ar' ? '.١XXXXXXXXX' : '01XXXXXXXXX'}`,
    SA: `${locale === 'ar' ? '.٥XXXXXXXX' : '05XXXXXXXX'}`,
    AE: `${locale === 'ar' ? '.٥XXXXXXXX' : '05XXXXXXXX'}`,
    OM: `${locale === 'ar' ? '٩XXXXXXX' : '9XXXXXXX'}`,
    BH: `${locale === 'ar' ? '٦٦٣XXXXX' : '663XXXXX'}`,
  };
  return phones[isoCode];
};

// In case we wanted to use full names in titles
export const getHeaderCurrencyFromIso = (locale, isoCode) => {
  const currencies = {
    EG: `${locale === 'ar' ? 'جنيه المصري' : 'Egyptian Pounds'}`,
    SA: `${locale === 'ar' ? 'ريال' : 'Riyal'}`,
    AE: `${locale === 'ar' ? 'درهم' : 'Dirham'}`,
  };
  return currencies[isoCode] || `${locale === 'ar' ? 'دولار' : 'Dollars'}`;
};

export const localizePaymentMethod = (locale, pm) => {
  const paymentMethods = {
    Runner: `${locale === 'ar' ? 'تحصيل من المنزل' : 'Pay From Home'}`,
    CreditCard: `${locale === 'ar' ? 'بطاقة ائتمانية' : 'Credit Card'}`,
    Fawry: `${locale === 'ar' ? 'فوري' : 'Fawry'}`,
    BankDeposit: `${locale === 'ar' ? 'ايداع بنكي' : 'Bank Deposit'}`,
    Office: `${locale === 'ar' ? 'مكتب لينكس' : 'Lynks Office'}`,
    Wallet: `${locale === 'ar' ? 'المحفظة' : 'Wallet'}`,
    Mada: `${locale === 'ar' ? 'مدى' : 'Mada'}`,
  };
  return paymentMethods[pm];
};

export const localizeOrderType = (locale, type) => {
  const orderTypes = {
    legacy_order: `${locale === 'ar' ? 'طلب' : 'Order'}`,
    LegacyOrder: `${locale === 'ar' ? 'طلب' : 'Order'}`,
    wallet: `${locale === 'ar' ? 'محفظة' : 'Wallet'}`,
    subscription: `${locale === 'ar' ? 'اشتراك' : 'Subscription'}`,
    services_return_request: `${locale === 'ar' ? 'طلب إرجاع' : 'Return Request'}`,
  };
  return orderTypes[type] || `${locale === 'ar' ? 'طلب' : 'Order'}`;
};

export const localizeCurrency = (locale, currencyCode) => {
  const currencies = {
    EGP: `${locale === 'ar' ? 'جنيه' : 'EGP'}`,
    SAR: `${locale === 'ar' ? 'ريال' : 'SAR'}`,
    AED: `${locale === 'ar' ? 'درهم' : 'AED'}`,
  };
  return currencies[currencyCode] || `${locale === 'ar' ? 'دولار' : 'USD'}`;
};

export const localizeNumber = (locale, number) => {
  // We no longer want to use arabic numbers in any case
  return number;

  const numbers = {
    '%': `${locale === 'ar' ? '%' : '%'}`,
    '-': `${locale === 'ar' ? '-' : '-'}`,
    ',': `${locale === 'ar' ? ',' : ','}`,
    '.': `${locale === 'ar' ? '.' : '.'}`,
    1: `${locale === 'ar' ? '1' : '1'}`,
    2: `${locale === 'ar' ? '2' : '2'}`,
    3: `${locale === 'ar' ? '3' : '3'}`,
    4: `${locale === 'ar' ? '4' : '4'}`,
    5: `${locale === 'ar' ? '5' : '5'}`,
    6: `${locale === 'ar' ? '6' : '6'}`,
    7: `${locale === 'ar' ? '7' : '7'}`,
    8: `${locale === 'ar' ? '8' : '8'}`,
    9: `${locale === 'ar' ? '9' : '9'}`,
    0: `${locale === 'ar' ? '0' : '0'}`,
  };
  const n = number.toString().split('').map((v) => numbers[v]).join('');
  return n;
};

export const getMonthName = (no, locale) => {
  const months = {
    1: `${locale === 'ar' ? 'يناير' : 'January'}`,
    2: `${locale === 'ar' ? 'فبراير' : 'February'}`,
    3: `${locale === 'ar' ? 'مارس' : 'March'}`,
    4: `${locale === 'ar' ? 'أبريل' : 'April'}`,
    5: `${locale === 'ar' ? 'مايو' : 'May'}`,
    6: `${locale === 'ar' ? 'يونيو' : 'June'}`,
    7: `${locale === 'ar' ? 'يوليو' : 'July'}`,
    8: `${locale === 'ar' ? 'أغسطس' : 'August'}`,
    9: `${locale === 'ar' ? 'سبتمبر' : 'September'}`,
    10: `${locale === 'ar' ? 'اكتوبر' : 'October'}`,
    11: `${locale === 'ar' ? 'نوفمبر' : 'November'}`,
    12: `${locale === 'ar' ? 'ديسمبر' : 'December'}`,
  };
  return months[no];
};

export const pounds_to_kg = (weight_pounds) => weight_pounds * 0.45359237;

export const simpleWayUser = (user, geoCode) => {
  const countryCode = user.country ? user.country.iso_code : geoCode;
  return ['OM', 'BH'].includes(countryCode);
};

// Getting date from number of days, with respect to NOW
export const getDateFromDays = (numberOfDays, locale) => {
  numberOfDays = parseInt(numberOfDays);
  const someDate = new Date();

  someDate.setDate(someDate.getDate() + numberOfDays);

  const dd = localizeNumber(locale, `${someDate.getDate()}`);
  const mm = getMonthName(`${someDate.getMonth() + 1}`, locale);
  const yyyy = localizeNumber(locale, `${someDate.getFullYear()}`);

  return `${dd} ${mm} ${yyyy}`;
};

export const isLink = (s) => {
  // eslint-disable-next-line no-useless-escape
  const regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
  return regexp.test(s);
};

export const get = (obj, key) => key.split('.').reduce((o, x) => (typeof o === 'undefined' || o === null) ? o : o[x], obj);

export const localizeSelector = (locale, selectorName) => {
  const selectors = {
    Color: `${locale === 'ar' ? 'اللون' : 'Color'}`,
    Size: `${locale === 'ar' ? 'المقاس' : 'Size'}`,
    Category: `${locale === 'ar' ? 'النوع' : 'Category'}`,
    Brand: `${locale === 'ar' ? 'الماركة' : 'Brand'}`,
  };
  return selectors[selectorName] || selectorName;
};

export const getCorrectShippingIcon = (stateMachineName) => {
  if (stateMachineName === 'ready_for_purchase' || stateMachineName === 'processed') {
    return 'hourglass two';
  } else if (stateMachineName === 'shipped_from_seller') {
    return 'shipping';
  }
  return 'home';
};

export const getItemInstanceState = (id, locale) => {
  const states = {
    40: locale === 'ar' ? 'قيد الإنتظار' : 'Pending',
    103: locale === 'ar' ? 'يتم مراجعته' : 'Under review',
    114: locale === 'ar' ? 'ﻳﻨﻘﺼﻪ ﻣﻌﻠﻮﻣﺎﺕ' : 'Missing Information',
    104: locale === 'ar' ? 'يحتاج إلى مزيد من المراجعة' : 'Needs further review',
    105: locale === 'ar' ? 'يحتاج لموافقة ليتم استيراده' : 'Needs import approval',
    41: locale === 'ar' ? 'تم مراجعته' : 'Reviewed',
    42: locale === 'ar' ? 'جاهز للشراء' : 'Ready for purchase',
    43: locale === 'ar' ? 'تم شراؤه' : 'Processed',
    44: locale === 'ar' ? 'تم شحنه من البائع' : 'Shipped from seller',
    92: locale === 'ar' ? 'محتجز' : 'On Hold',
    45: locale === 'ar' ? 'وصل إلى مكتب أمريكا' : 'Arrived at US Office',
    217: locale === 'ar' ? 'سيتم شحنه قريباً' : 'Will be Shipped Soon',
    93: locale === 'ar' ? 'يتم تجهيزه للشحن' : 'Preparing for Shipment',
    46: locale === 'ar' ? 'في الطريق إلى بلد المستلم' : 'En Route to Destination',
    47: locale === 'ar' ? 'وصل إلى الجمارك' : 'Arrived at Customs',
    95: locale === 'ar' ? 'محتجز لدى الجمارك' : 'Held at Customs',
    48: locale === 'ar' ? 'وصل الى مكتب لينكس' : 'Arrived at lynks Office',
    49: locale === 'ar' ? 'وصل إلى مكتب الإسكندرية' : 'Arrived at Alexandria',
    85: locale === 'ar' ? 'جاهز للإستلام' : 'Ready for pick up',
    51: locale === 'ar' ? 'يتم توصيله' : 'Out for delivery',
    50: locale === 'ar' ? 'تم استلامه' : 'Picked up',
    52: locale === 'ar' ? 'تم توصيله' : 'Delivered',
    55: locale === 'ar' ? 'تم طلب إعادة المنتج' : 'Return requested',
    56: locale === 'ar' ? 'تم إعادته إلى مكتب الإسكندرية' : 'Returned to Alexandria',
    57: locale === 'ar' ? 'تم اعادته إلى مكتب لينكس' : 'Returned to lynks Office',
    58: locale === 'ar' ? 'في الطريق إلى أمريكا' : 'En route to USA',
    59: locale === 'ar' ? 'تم إعادته إلى مكتب أمريكا' : 'Returned to US office',
    60: locale === 'ar' ? 'تم إعادته إلى البائع' : 'Returned to seller',
    61: locale === 'ar' ? 'تم إعادته' : 'Return completed',
    91: locale === 'ar' ? 'غير متطابق' : 'Mismatched',
    90: locale === 'ar' ? 'تالف' : 'Damaged',
    54: locale === 'ar' ? 'ضائع' : 'Missing',
    5: locale === 'ar' ? 'ملغي' : 'Cancelled',
  };
  return states[id] || states;
};

export const getLegacyOrderState = (id, locale) => {
  const states = {
    34: locale === 'ar' ? 'انتهت صلاحيته' : 'Expired',
    161: locale === 'ar' ? 'إختيارات' : 'Picks',
    146: locale === 'ar' ? 'محفظة' : 'Links Wallet',
    27: locale === 'ar' ? 'عربة التسوق' : 'Cart',
    179: locale === 'ar' ? 'الاقتراحات' : 'Recommendations',
    8: locale === 'ar' ? 'قيد المراجعة' : 'Pending Review',
    33: locale === 'ar' ? 'مطلوب مراجعته' : 'Review requested',
    32: locale === 'ar' ? 'يتم مراجعته' : 'Under review',
    68: locale === 'ar' ? 'ينقصه معلومات' : 'Missing Information',
    14: locale === 'ar' ? 'بإنتظار إنهاء عملية الدفع' : 'Pending Checkout',
    15: locale === 'ar' ? 'قيد الدفع' : 'Waiting for Payment',
    67: locale === 'ar' ? 'تم إرسال المندوب' : 'Runner Sent',
    16: locale === 'ar' ? 'جاهز للشراء' : 'Ready to Process',
    35: locale === 'ar' ? 'قيد الشراء' : 'Processing',
    10: locale === 'ar' ? 'تم شراؤه' : 'Processed',
    86: locale === 'ar' ? 'جاهز للإستلام' : 'Ready for pick up',
    17: locale === 'ar' ? 'جاري توصيله' : 'Out for Delivery',
    11: locale === 'ar' ? 'تم توصيل الطلب' : 'Completed',
    12: locale === 'ar' ? 'ملغي' : 'Cancelled',
    1: locale === 'ar' ? 'لا يمكن شراؤه' : 'Unable to Fulfill',
  };
  return states[id] || states;
};

export const getStepsIdsFromType = (type, state_id) => {
  const steps = {
    ItemInstance: ['42', '43', '44', '45', '93', '46', '47', '48', '51', '52'],
    LegacyOrder: ['15', '16', '35', '10', '17', '11'],
  };

  if (type === 'LegacyOrder') {
    if (state_id === '15') {
      return ['15', '16', '10', '17'];
    } else if (state_id === '16') {
      return ['16', '10', '17', '11'];
    } else if (state_id === '35') {
      return ['16', '35', '17', '11'];
    }
    return ['16', '10', '17', '11'];
  }

  return steps[type] || [];
};

export const isNull = (input) => [null, 'null', 'NULL', 'nil'].includes(input);

export function asCurrency(number) {
  if (number === null || number === undefined) return '--';
  return number
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}



// WEBPACK FOOTER //
// ./app/lib/newHelpers.js